import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AuthGuard } from '../../auth-guard.service';
const routes: Routes = [
  {
    path: 'configuracion/dashboard-escolar',
    children: [
       { path: 'dashboard', component: DashboardComponent},
    ],
    canActivate: [AuthGuard]
  }  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardEscolarRoutingModule { }
